import React from 'react'

import { LoadingPlaceholder } from '@sketch/components'

import { Thumbnail, TileThumbnail } from './TileCard.styles'

interface DocumentTileMediaProps {
  /** Thumbnail URL; when absent a neutral placeholder tile is shown instead. */
  src?: string | null
  alt: string
}

/** Document thumbnail for a preview card tile, with a placeholder fallback. */
export const DocumentTileMedia = ({ src, alt }: DocumentTileMediaProps) =>
  src ? (
    <TileThumbnail
      src={src}
      alt={alt}
      loadingPlaceholder={<LoadingPlaceholder />}
    />
  ) : (
    <Thumbnail aria-hidden />
  )
